const print = {
    breakLine: function (length, symbol = "-") {
        let result = "";
        for (let index = 0; index < length; index++) {
            result += symbol;
        }
        return result;
    },
    oneLine: function (str, chunkSize, align = "left") {
        if (typeof str !== "string") throw new Error("Input harus berupa string!");
        if (!Number.isInteger(chunkSize) || chunkSize <= 0) throw new Error("chunkSize harus bilangan bulat positif!");

        let words = str.split(" "); // Pisahkan kata-kata berdasarkan spasi
        let result = [];
        let line = "";

        words.forEach(word => {
            // Jika kata berikutnya melebihi batas, simpan baris saat ini dan mulai baris baru
            if ((line + word).length > chunkSize) {
                result.push(this.alignText(line.trim(), chunkSize, align));
                line = word + " ";
            } else {
                line += word + " ";
            }
        });

        // Tambahkan baris terakhir jika ada
        if (line.trim().length > 0) {
            result.push(this.alignText(line.trim(), chunkSize, align));
        }

        return this.joinRows(result);
    },
    twoColumn: function (leftText, rightText, leftColSize, spaceSize, rightColSize) {
        let result = [];
        let spaceStr = " ".repeat(spaceSize); // Spasi pemisah antar kolom

        let leftChunks = this.chunkTextPreserveSpace(leftText, leftColSize);
        let rightChunks = this.chunkTextRightAlign(rightText, rightColSize);

        let maxLines = Math.max(leftChunks.length, rightChunks.length);

        for (let i = 0; i < maxLines; i++) {
            let leftPart = leftChunks[i] || "".padEnd(leftColSize, " "); // Rata kiri
            let rightPart = rightChunks[i] ? rightChunks[i].padStart(rightColSize, " ") : "".padStart(rightColSize, " "); // Rata kanan

            result.push(leftPart + spaceStr + rightPart);
        }

        return result.join("\n");
    },
    twoColumnLeftAlign: function (leftText, rightText, leftColSize, spaceSize, rightColSize) {
        let result = [];
        let spaceStr = " ".repeat(spaceSize); // Spasi pemisah antar kolom
        let indent = "  "; // Dua spasi untuk baris baru di kolom kanan

        // Pisahkan teks berdasarkan kata
        let leftChunks = this.chunkText(leftText, leftColSize);
        let rightChunks = this.chunkTextPreserveSpaceWithIndent(rightText, rightColSize, indent);

        // Maksimum jumlah baris yang dibutuhkan
        let maxLines = Math.max(leftChunks.length, rightChunks.length);

        for (let i = 0; i < maxLines; i++) {
            let leftPart = leftChunks[i] || ""; // Jika tidak ada teks, isi dengan string kosong
            let rightPart = rightChunks[i] || "";

            // Rata kiri dengan memastikan setiap bagian memiliki panjang sesuai ukuran kolom
            leftPart = leftPart.padEnd(leftColSize, " ");

            result.push(leftPart + spaceStr + rightPart);
        }

        return result.join("\n"); // Gabungkan baris dengan newline
    },
    // tablePrint: function (left, right, maks) {
    //     const countLeft = left.length;
    //     const countRight = right.length;
    //     let result = [];
    //     for (let index = 0; index < maks; index++) {
    //         result[index] = countLeft > index ? left[index] : " ";
    //     }

    //     let indexRight = countRight;
    //     for (let index = (maks - 1); index >= 0; index--) {
    //         if ((maks - countRight) <= index) {
    //             indexRight--;
    //             result[index] = right[indexRight];
    //         }
    //     }
    //     return result.join("");
    // },
    centerTextByCharacter: function (text, maxLength) {
        if (typeof text !== "string") throw new Error("Input harus berupa string!");
        if (!Number.isInteger(maxLength) || maxLength <= 0) throw new Error("maxLength harus bilangan bulat positif!");

        let words = text.split(" ");
        let lines = [];
        let currentLine = "";

        for (let word of words) {
            if ((currentLine.length + word.length + (currentLine.length > 0 ? 1 : 0)) <= maxLength) {
                // Tambahkan kata ke baris jika masih cukup
                currentLine += (currentLine.length === 0 ? "" : " ") + word;
            } else {
                // Simpan baris sebelumnya dengan rata tengah
                let paddingLeft = Math.max(0, Math.floor((maxLength - currentLine.length) / 2));
                let paddingRight = Math.max(0, maxLength - currentLine.length - paddingLeft);
                lines.push(" ".repeat(paddingLeft) + currentLine + " ".repeat(paddingRight));

                // Mulai baris baru dengan kata saat ini
                currentLine = word;
            }
        }

        // Tambahkan baris terakhir jika ada
        if (currentLine.length > 0) {
            let paddingLeft = Math.max(0, Math.floor((maxLength - currentLine.length) / 2));
            let paddingRight = Math.max(0, maxLength - currentLine.length - paddingLeft);
            lines.push(" ".repeat(paddingLeft) + currentLine + " ".repeat(paddingRight));
        }

        return this.joinRows(lines);
    },
    joinRows(array) {
        if (!Array.isArray(array[0])) {
            return array.join(""); // Jika hanya 1 dimensi, gabungkan langsung jadi 1 baris
        }

        return array.map(row => row.join("")).join("\n");
    },
    // Fungsi untuk meratakan teks sesuai dengan opsi (left, center, right)
    alignText: function (text, maxLength, align) {
        if (align === "center") {
            let paddingLeft = Math.floor((maxLength - text.length) / 2);
            let paddingRight = maxLength - text.length - paddingLeft;
            return " ".repeat(paddingLeft) + text + " ".repeat(paddingRight);
        }
        if (align === "right") {
            return text.padStart(maxLength, " ");
        }
        return text.padEnd(maxLength, " "); // Default rata kiri
    },
    // Fungsi untuk memecah teks berdasarkan kata dan mempertahankan spasi awal
    chunkTextPreserveSpace: function (text, chunkSize) {
        let words = text.split(/(\s+)/); // Pisahkan berdasarkan spasi (termasuk spasi sebagai token)
        let result = [];
        let line = "";

        words.forEach((word) => {
            if ((line + word).length > chunkSize) {
                result.push(line.padEnd(chunkSize, " ")); // Tambahkan padding jika kurang dari chunkSize
                line = word.trimStart(); // Mulai baris baru dengan menghapus spasi awal yang berlebih
            } else {
                line += word;
            }
        });

        if (line.length > 0) {
            result.push(line.padEnd(chunkSize, " "));
        }

        return result;
    },
    // Fungsi untuk memecah teks kanan dan memastikan rata kanan
    chunkTextRightAlign: function (text, chunkSize) {
        let words = text.split(" ");
        let result = [];
        let line = "";

        words.forEach((word, index) => {
            let wordWithSpace = (index === 0 ? "" : " ") + word; // Tambahkan spasi antar kata

            if ((line + wordWithSpace).length > chunkSize) {
                result.push(line.padStart(chunkSize, " ")); // Pastikan teks rata kanan
                line = word; // Mulai baris baru
            } else {
                line += wordWithSpace;
            }
        });

        if (line.length > 0) {
            result.push(line.padStart(chunkSize, " "));
        }

        return result;
    },
    // Fungsi untuk memecah teks kanan dengan indentasi 2 spasi di baris baru
    chunkTextPreserveSpaceWithIndent: function (text, chunkSize, indent) {
        let words = text.split(/(\s+)/); // Pisahkan berdasarkan spasi (termasuk spasi sebagai token)
        let result = [];
        let line = "";
        let firstLine = true;

        words.forEach((word) => {
            let effectiveChunkSize = firstLine ? chunkSize : chunkSize - indent.length;

            if ((line + word).length > effectiveChunkSize) {
                result.push(line.padEnd(effectiveChunkSize, " "));

                // Hilangkan spasi sebelum kata jika ada, tetapi tetap tambahkan indentasi 2 spasi
                line = indent + word.trimStart();
                firstLine = false;
            } else {
                line += word;
            }
        });

        if (line.length > 0) {
            result.push(line.padEnd(firstLine ? chunkSize : chunkSize - indent.length, " "));
        }

        return result;
    },
    chunkText: function (text, maxLength) {
        let words = text.split(" ");
        let result = [];
        let line = "";

        for (let word of words) {
            if ((line + word).length > maxLength) {
                result.push(line.trim()); // Simpan baris yang sudah penuh
                line = word + " "; // Mulai baris baru dengan kata berikutnya
            } else {
                line += word + " ";
            }
        }

        if (line.trim().length > 0) {
            result.push(line.trim()); // Simpan baris terakhir jika ada
        }

        return result;
    },
    /**
 * Format text into two columns with proper spacing and character limits
 * @param {string} left - Left column text
 * @param {string} right - Right column text
 * @param {number} maxLength - Maximum line length (default: 40)
 * @param {number} leftWidth - Maximum width for left column (default: 24)
 * @param {number} rightWidth - Maximum width for right column (default: 16)
 * @param {number} spacing - Number of spaces between columns (default: 2)
 * @returns {string} Formatted line with two columns
 */
    /**
     * Format data into a table with multiple columns and rows
     * @param {Array} columns - Array of column configurations {header: string, key: string, width: number, align?: 'left'|'right'|'center'}
     * @param {Array} records - Array of objects containing the data to display
     * @param {Object} options - Optional configuration
     * @param {number} options.spacing - Number of spaces between columns (default: 2)
     * @returns {string} Formatted table as string
     */
    tablePrint: function (columns, records, options = {}) {
        const { spacing = 2 } = options;
        let result = [];
        
        // Calculate total width for maxLength check
        const totalWidth = columns.reduce((sum, col) => sum + (col.width || 20) + spacing, -spacing);
        
        // Create header
        const header = columns.map(col => {
            const headerText = col.header || col.key;
            return this.alignText(headerText, col.width || 20, col.align || 'left');
        }).join(' '.repeat(spacing));
        
        result.push(header);
        result.push('='.repeat(header.length));
        
        // Add rows
        records.forEach(record => {
            const row = columns.map(col => {
                const value = record[col.key] !== undefined ? String(record[col.key]) : '';
                return this.alignText(value, col.width || 20, col.align || 'left');
            }).join(' '.repeat(spacing));
            
            // Ensure the line doesn't exceed total width
            result.push(row.substring(0, totalWidth));
        });
        
        return result.join('\n');
    }
}

export default print;